import { render, staticRenderFns } from "./postcode.vue?vue&type=template&id=1be25a08&scoped=true&"
import script from "./postcode.vue?vue&type=script&lang=js&"
export * from "./postcode.vue?vue&type=script&lang=js&"
import style0 from "./postcode.vue?vue&type=style&index=0&id=1be25a08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be25a08",
  null
  
)

export default component.exports